
export default [
    {
      path: '/collectMoney/icCard',
      component: resolve => require(['../page.vue'], resolve),
      meta: {
          title: 'IC卡转会员',
          keepAlive: false
      }
    },   
];
  